import { VariableNames } from "../../../../UserInterfaceModule/Constants/VariableNames";
import { CollectionFilterExpression } from "../../../Models/Collections/CollectionFilterExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class CollectionFilterExpressionEvaluator implements IExpressionEvaluator<CollectionFilterExpression>, IHasExpressionMetadata {
  private static _expressionPropertyNames: string[] = ["Collection", /*"Filter"*/];

  get expressionProperties(): string[] {
    return CollectionFilterExpressionEvaluator._expressionPropertyNames;
  }

  get type(): string {
    return "CollectionFilter";
  }

  evaluate(expression: CollectionFilterExpression, context: IExpressionEvaluatorContext): MaybePromise {
    const collection = context.Evaluator.evaluate(expression.Collection, context);

    if (collection instanceof Promise) {
      return collection.then((resolvedCollection) => {
        //console.log("[CollectionFilter] collection (resolved):", resolvedCollection);
        return this.filterCollection(resolvedCollection, expression, context);
      });
    }

    //console.log("[CollectionFilter] collection:", collection);
    return this.filterCollection(collection, expression, context);
  }

  private filterCollection(collection: any[], expression: CollectionFilterExpression, context: IExpressionEvaluatorContext): MaybePromise {
    if (!Array.isArray(collection)) {
      return [];
    }

    const items: any[] = [];
    const filterResults: any[] = [];
    let hasPromise = false;

    for (const item of collection) {
      const childContext = context.CreateChild();
      childContext.VariableScope.set(VariableNames.Item, item);

      const filterResult = context.Evaluator.evaluate(expression.Filter, childContext);
      items.push(item);
      filterResults.push(filterResult);
      if (filterResult instanceof Promise) {
        hasPromise = true;
      }
    }

    // If any promise exists, wait for all and then filter
    if (hasPromise) {
      return Promise.all(filterResults).then((results) => this.buildFilteredArray(items, results));
    }

    // All sync, filter immediately
    return this.buildFilteredArray(items, filterResults);
  }

  private buildFilteredArray(items: any[], filterResults: any[]): any[] {
    const result: any[] = [];
    for (let i = 0; i < items.length; i++) {
      if (filterResults[i]) {
        result.push(items[i]);
      }
    }
    //console.log("[CollectionFilter] filtered result:", result);
    return result;
  }
}
